import { Trans } from '@lingui/macro';
import { Stack, Typography, Box, Fade, Divider } from '@mui/material';
import { useUserProfile } from 'atoms/user-profile';
import CommunityInviteForm from 'components/community-invite-form/CommunityInviteForm';
import OnboardingStepper from 'components/onboarding-flow/OnboardingStepper';
import React from 'react';

export default function EducationalOnboardingCorridorInvite() {
  const { userProfile } = useUserProfile();
  return (
    <Fade in>
      <Stack alignItems='center'>
        <Box mt={4} />
        <Typography variant='h1' textAlign='center'>
          <Trans>Invite members to your community</Trans>
        </Typography>
        <Typography mt={4} variant='subtitle1' textAlign='center'>
          <Trans>
            CoCo is especially designed for collaborating with peers.
          </Trans>
          <br />
          <Trans>
            Make sure to invite others you know to experience it in action.
          </Trans>
        </Typography>
        <Box mt={2} />
        <Divider sx={{ width: '100%' }} />
        <Box mt={2} />
        <CommunityInviteForm
          showRequest={!userProfile?.educationalAccessApproved}
        />
        <Box mt={4} />
        <OnboardingStepper totalSteps={4} activeStep={3} />
      </Stack>
    </Fade>
  );
}
